import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=496d0d63&scoped=true&"
import script from "./HeaderSection.vue?vue&type=script&lang=js&"
export * from "./HeaderSection.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSection.vue?vue&type=style&index=0&id=496d0d63&prod&lang=scss&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d0d63",
  null
  
)

export default component.exports